import { format } from "date-fns";

// Formats a date range, e.g. "Jan/01/2026 to Jan/15/2026" ("--" when a date is missing)
export const formatPeriod = (from, to) =>
  `${from ? format(new Date(from), "MMM/dd/yyyy") : "--"} to ${
    to ? format(new Date(to), "MMM/dd/yyyy") : "--"
  }`;
